import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { apiMiddleware as reduxApiMiddleware } from 'redux-api-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';

export default function configureStore(initialState, history) {
    let finalCreateStore;

    if (__DEV__) {
        finalCreateStore = composeWithDevTools(
            applyMiddleware(require('redux-immutable-state-invariant')()), // eslint-disable-line global-require
            applyMiddleware(thunk),
            applyMiddleware(reduxApiMiddleware),
            __CLIENT__ ? applyMiddleware(routerMiddleware(history)) : f => f,
        )(createStore);
    } else {
        finalCreateStore = compose(
            applyMiddleware(thunk),
            applyMiddleware(reduxApiMiddleware),
            __CLIENT__ ? applyMiddleware(routerMiddleware(history)) : f => f,
        )(createStore);
    }

    const store = finalCreateStore(rootReducer(history), initialState);

    return store;
}
